import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { BroadcastingInfo } from 'src/app/models/broadcastings-models/broadcasting-info.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-broadcasting-dashboard',
  templateUrl: './broadcastings-broadcasting-dashboard.component.html',
  styleUrls: ['./broadcastings-broadcasting-dashboard.component.scss']
})
export class BroadcastingsBroadcastingDashboardComponent implements OnInit, OnDestroy {

  broadcasting: BroadcastingInfo;
  devices: DeviceBasic[];
  internalIdList: DeviceBasic[];
  existingSchedules;
  getBroadcastingInfoSubscription: Subscription;
  getBroadcastingDevicesSubscription: Subscription;
  refreshBroadcastingSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getBroadcastingInfo();
    this.refreshBroadcastingSubscription = this.broadcastingsService.refreshBroadcastingListen().pipe(
      tap(o => this.getBroadcastingInfo())
    ).subscribe();
  }

  public getBroadcastingInfo() {
    const internalId = this.activatedRoute.snapshot.params['broadcastingid'];
    this.getBroadcastingInfoSubscription = this.broadcastingsService.getBroadcastingInfo(internalId).pipe(
      tap(o => this.broadcasting = o),
      tap(o => this.getBroadcastingDevices()),
      tap(o => this.getBroadcastingExistingSchedules()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getBroadcastingDevices() {
    const internalIdList = new Array<string>();
    this.broadcasting.CenterBound.forEach(
      (c) => {
        internalIdList.push(c.InternalId);
      }
    );
    this.getBroadcastingDevicesSubscription = this.broadcastingsService.getBroadcastingDevices(internalIdList).pipe(
      tap(o => this.devices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getBroadcastingExistingSchedules() {
    this.broadcastingsService.getBroadcastingExistingSchedules(this.broadcasting.CenterBound).pipe(
      tap(o => this.existingSchedules = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-photo-video', 'broadcastings-page.broadcasting detail', '/broadcastings/broadcastings', [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.broadcastings', '/broadcastings/broadcastings'), new BRoute('broadcastings-page.broadcasting detail')]));
  }

  ngOnDestroy() {
    if (this.getBroadcastingInfoSubscription) { this.getBroadcastingInfoSubscription.unsubscribe(); }
    if (this.getBroadcastingDevicesSubscription) { this.getBroadcastingDevicesSubscription.unsubscribe(); }
    if (this.refreshBroadcastingSubscription) { this.refreshBroadcastingSubscription.unsubscribe(); }
  }
}

